<script setup lang="ts">
import ServiceSettingAddStep3 from "@/views/playground/planner/order-management/service-setting/add/ServiceSettingAddStep3.vue";
</script>

<template>
  <service-setting-add-step3></service-setting-add-step3>
</template>

<style scoped></style>
